import { CrossFrameUtils } from '@src/utils';

const CROSS_FRAME_TIMEOUT_MS = 10000;

export async function translateText(text: string, targetLanguage?: string, toolName?: string): Promise<string> {
    if (!text) return text;
    try {
        return await CrossFrameUtils.sendMessageToOtherFrame({
            frame: window.top,
            message: { method: 'translateText', data: { text, targetLanguage, toolName }, crossFrameTimeoutMillis: CROSS_FRAME_TIMEOUT_MS },
        });
    } catch (error) {
        console.error('TranslationHelper: translateText failed, returning original', error);
        return text;
    }
}

export async function translateTextBatch(texts: string[], targetLanguage?: string, toolName?: string): Promise<string[]> {
    if (!texts?.length) return [];
    try {
        return await CrossFrameUtils.sendMessageToOtherFrame({
            frame: window.top,
            message: { method: 'translateTextBatch', data: { texts, targetLanguage, toolName }, crossFrameTimeoutMillis: CROSS_FRAME_TIMEOUT_MS },
        });
    } catch (error) {
        console.error('TranslationHelper: translateTextBatch failed, returning originals', error);
        return texts;
    }
}

export async function getSupportedLanguages(): Promise<string[]> {
    try {
        return await CrossFrameUtils.sendMessageToOtherFrame({
            frame: window.top,
            message: { method: 'getSupportedLanguages', data: {}, crossFrameTimeoutMillis: CROSS_FRAME_TIMEOUT_MS },
        });
    } catch (error) {
        console.error('TranslationHelper: getSupportedLanguages failed', error);
        return [];
    }
}
